import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface BulkPaymentHistoryByDateItem {
  studentId: string | null;
  name: string;
  amount: string;
  status: string;
  dateProcessed: string | null;
  paidDate: string | null;
  failureReason?: string | null;
}

export const getBulkPaymentHistoryByDate = async (bulkPaymentId: string) => {
  const response = await baseAPI.get<Array<BulkPaymentHistoryByDateItem>>(
    `subscription-invoices/bulk-charge-history/${bulkPaymentId}`,
  );
  return response.data;
};

export const useGetBulkPaymentHistoryByDate = (bulkPaymentId: string) => {
  return useQuery({
    queryKey: [KEYS.BULK_CHARGE_HISTORY, bulkPaymentId],
    queryFn: () => getBulkPaymentHistoryByDate(bulkPaymentId),
    enabled: !!bulkPaymentId,
  });
};
